import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NewSystemColorDialogComponent } from '@components/new-system-color-dialog/new-system-color-dialog.component';
import { SystemColorContainerType } from '@models/system-color';
import { SystemColorService } from '@service/system-color.service';
import { SystemColorType } from 'icreate/common/models/system-color';
import { Vessel } from 'icreate/common/models/vessel';

@Component({
    selector: 'app-custom-system-color-container',
    templateUrl: './custom-system-color-container.component.html',
    styleUrls: ['./custom-system-color-container.component.css'],
    standalone: false,
})
export class CustomSystemColorContainerComponent {
    @Input() data!: SystemColorContainerType;
    @Input() vessel!: Vessel;
    @Input() canEditVessel: boolean;

    constructor(
        private dialog: MatDialog,
        private systemColorService: SystemColorService
    ) {}

    async addCustomColorClick() {
        if (!this.canEditVessel) return;
        const systemColorList = await this.systemColorService.getAll(this.vessel.id);
        this.dialog.open(NewSystemColorDialogComponent, {
            width: '474px',
            autoFocus: false,
            data: {
                name: '',
                color: '',
                type: SystemColorType.Custom,
                isEditable: true,
                mode: '',
                vesselId: this.vessel.id,
                systemColorList,
            },
        });
    }
}
